import SvgIcon from '@home/components/SvgIcon';
import { editIcon, IconType } from '@op/constants/chart';
import React, { useMemo } from 'react';
import { useMdToHtml } from '../hooks';
import { SummaryTabItem } from '../types';
import './index.scss';
import { NoDataCard, NoDataCardProps } from '@op/components/NoDataCommon';
import useLanguage from '@op/hooks/useLanguage';
import { NO_DATE } from '@op/constants';
import { Button } from 'tea-component';
import DOMPurify from 'dompurify';

export default function RichTextShowBox({
  item,
  operations = [],
  handOperations,
  bodyHeight,
  isFull,
  setRef,
  emptyProps,
  canEdit,
}: {
  item: SummaryTabItem;
  operations?: Array<IconType>;
  handOperations?: (item: IconType) => void;
  bodyHeight?: number;
  isFull: boolean;
  setRef: (value: HTMLDivElement) => void;
  emptyProps?: Omit<NoDataCardProps, 'emptyDescElement'> & {
    emptyDescElement?: (openEdit: () => void) => any;
  };
  canEdit: boolean;
}) {
  const { formatMessage } = useLanguage();
  const { renderHtml, isEmpty } = useMdToHtml({ item, watch: true });

  const emptyDescElementFunc = useMemo(() => {
    if (emptyProps?.emptyDescElement) {
      return emptyProps?.emptyDescElement?.(() => handOperations?.(editIcon));
    }
    return (
      <div style={{ display: 'flex', alignItems: 'center' }}>
        {formatMessage(NO_DATE.LOADING)}
        {canEdit && (
          <>
            ,
            <Button
              style={{ paddingLeft: 5, height: 44 }}
              onClick={() => handOperations?.(editIcon)}
              type="link"
            >
              {formatMessage('Please fill in')}
            </Button>
          </>
        )}
      </div>
    );
  }, [formatMessage]);

  return (
    <div className={`dbo-rich-text-show-box-wrapper`}>
      {operations.length > 0 && (
        <div className="dbo-rich-text-operations">
          {operations.map((item) => (
            <SvgIcon
              key={item.symbol}
              type={item.icon}
              onClick={() => handOperations?.(item)}
              style={{ transform: `rotate(${item.rotate || 0}deg)` }}
              className="dbo-rich-text-operations-icon"
            />
          ))}
        </div>
      )}
      <NoDataCard
        empty={isEmpty}
        hasDesc={false}
        {...emptyProps}
        emptyDescElement={emptyDescElementFunc}
      >
        <p
          className={`dbo-rich-text-show-content  ${
            isFull ? '' : '--dbo-scroll-body'
          }`}
          ref={setRef}
          style={{ maxHeight: bodyHeight }}
          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(renderHtml!) }}
        ></p>
      </NoDataCard>
    </div>
  );
}
